import React from 'react';
import { Link } from 'react-router-dom';
import { Artist } from '../types/content';
type ArtistCardProps = {
  artist: Artist;
};
export function ArtistCard({
  artist
}: ArtistCardProps) {
  const excerpt = artist.bio[0];
  return <Link to={`/artist/${artist.slug}`} className="group flex h-full flex-col" data-id="element-33" data-mp="3i41zt6coe8sj">
      <div className="aspect-[4/5] overflow-hidden bg-ink-surface" data-id="element-34" data-mp="3n1kd18xq7a6c">
        <img src={artist.image} alt={`Portrait of ${artist.name}`} loading="lazy" className="h-full w-full object-cover grayscale transition-[filter,transform] duration-300 ease-out group-hover:scale-[1.03] group-hover:grayscale-0" data-id="element-35" data-mp="2pf3ho98jz6n8" />
      </div>
      <h3 className="mt-5 font-slab text-lg font-bold uppercase tracking-[0.2em] group-hover:underline group-hover:underline-offset-8" data-id="element-36" data-mp="343hhscel4h03">
        {artist.name}
      </h3>
      <p className="mt-1 font-script text-base italic text-ink-muted" data-id="element-37" data-mp="26m9cg70qesw7">{artist.roles.join(' · ')}</p>
      {excerpt && <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-ink-muted" data-id="element-38" data-mp="2bl3u35myqbeq">{excerpt}</p>}
    </Link>;
}